import { LocalDateTime } from "@js-joda/core";
import { InstaPayVisit } from "../messages";

export function splitInstaPayVisitsByPeriod(params: { visits: InstaPayVisit[] }) {
  const localNow = LocalDateTime.now();
  const past: InstaPayVisit[] = [];
  const current = [];
  const future: InstaPayVisit[] = [];

  for (const visit of params.visits) {
    if (visit.endTime.isBefore(localNow)) {
      past.push(visit);
      continue;
    }

    if (visit.startTime.isAfter(localNow)) {
      future.push(visit);
      continue;
    }

    current.push(visit);
  }

  return { past, current, future };
}
